import { render, staticRenderFns } from "./ReadonlyCard.vue?vue&type=template&id=67ba6fec&"
import script from "./ReadonlyCard.vue?vue&type=script&lang=ts&"
export * from "./ReadonlyCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports